import ServiceCard from '../components/ServiceCard';
import { NavLink } from "react-router-dom";

const Home = () => {
  const services = [
    { title: 'Experienced Team', description: 'Our team of experienced healthcare professionals includes qualified registered nurses, occupational therapists, physiotherapy support workers and carers.' },
    { title: '24/7 Support', description: 'We are always available to answer your need. With ABHA Care, you have the support you need whenever you need it.' },
    { title: 'Holistic Approach', description: 'Staying true to our commitment, we provide personalised NDIS services with medical expertise.' },
  ];

  return (
    <main>
      
      <section className="relative w-screen h-screen flex items-center justify-center">
        {/* Background Image */}
        <img
          src="/images/AbhaCare.jpg"
          alt="HomePicture"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Green Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-green-900/70 via-green-900/40 to-green-300/40"></div>

        {/* Content */}
        <div className="relative z-10 text-center text-white px-6 max-w-4xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-inter mb-6">
            Welcome to ABHA CARE!
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 leading-relaxed">
            <strong>ABHA Care</strong> is an NDIS disability support services provider that believes in
            the potential of people with disabilities. We are committed to empowering this potential by
            helping them live independently through safe, respectful, and personalised care that meets
            their needs.
            <br /><br />
            Our team of skilled and experienced professionals ensures you will always feel valued and
            understood and will support you throughout this journey.
          </p>
          {/*<button className="bg-white text-black font-semibold px-6 sm:px-8 py-2 sm:py-3 rounded-full shadow-lg hover:bg-gray-200 transition">
            Learn More*/}
            <NavLink to="/contact">
            <button className="bg-transparent text-white font-semibold px-6 sm:px-8 py-2 sm:py-3 rounded-full border-2 hover:bg-green-900">
            Learn More</button> </NavLink>
        </div>
      </section>

      {/*Our  Services */}
    <section className="relative w-screen h-screen flex flex-col lg:flex-row items-center justify-center">
  {/* Background Image */}
  <div className="relative w-full lg:w-2/3 h-1/2 lg:h-full">
    <img
      src="/images/AbhaAgedPhoto.jpg"
      alt="ServicesPicture"
      className="w-full h-full object-cover"
    />
  </div>

  {/* Content */}
  <div className="relative z-10 bg-[#588157] text-white px-6 sm:px-10 py-8 max-w-xl rounded-md shadow-lg
                  -translate-y-8 lg:-translate-x-1/3">
   <p className="text-sm sm:text-base md:text-lg text-[#3f4f2b] font-bold font-inter mb-4 text-left">
      ABHA CARE DISABILITY SERVICES
    </p>
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold font-inter mb-4 text-left">
      Our Services
    </h2>
    <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 leading-relaxed text-left font-inter">
     Our Life Skills Development and Training program empowers NDIS participants to build confidence, independence, 
     and essential everyday living skills. Through a person-centred and hands-on approach, we tailor support to each 
     participant’s unique goals, abilities, and interests. Our experienced and caring staff provide one-on-one or small 
     group training, helping participants learn, practice, and apply vital life skills in real-life settings at home 
     and within the community to promote greater independence and active participation in daily life.
    </p>
   <NavLink to="/contact" class="ct-link-text font-semibold color-secondary underline"> Contact Us Today → </NavLink>

  </div>
</section>


      <section className="relative w-screen h-auto translate-y-4 md:translate-y-12 p-24 mt-0 bg-white">
       <h4 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 px-4 sm:px-10 md:px-20 lg:px-60 text-left">
        Why Choose ABHA Care?
      </h4>
      <p className="text-base sm:text-lg md:text-xl mb-14 px-4 sm:px-10 md:px-20 lg:px-60 text-left">
      The right NDIS support provider for your disability care is the key to improving your
      <br className="hidden sm:block" />quality of life. These are what makes ABHA Care stand out:</p>

  <div className="container mx-auto my-0 px-6 lg:px-20">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

      {/* Card 1 */}
      <div className="flex flex-col items-start">
        <img
          src="/images/AbhaExperience.jpg"
          alt="Experienced Team"
          className="rounded-lg shadow-md mb-6 object-cover"
        />
        <h3 className="text-xl font-bold mb-4">Experienced Team</h3>
        <p className="text-gray-700 mb-4">
          Our team of experienced healthcare professionals includes qualified
          registered nurses, occupational therapists, physiotherapy support
          workers and carers.
        </p>
        <a
          href="/contact"
          className="text-green-700 font-semibold hover:underline inline-flex items-center"
        >
          Contact Us →
        </a>
      </div>

      {/* Card 2 */}
      <div className="flex flex-col items-start">
        <img
          src="/images/24x7Support.jpg"
          alt="24/7 Support"
          className="rounded-lg shadow-md mb-6 object-cover"
        />
        <h3 className="text-xl font-bold mb-4">24/7 Support</h3>
        <p className="text-gray-700 mb-4">
          We are always available to answer your need. With ABHA Care, you have
          the support you need whenever you need it.
        </p>
        <a
          href="/contact"
          className="text-green-700 font-semibold hover:underline inline-flex items-center"
        >
          Contact Us →
        </a>
      </div>

      {/* Card 3 */}
      <div className="flex flex-col items-start">
        <img
          src="/images/HolisticApproach.jpg"
          alt="Holistic Approach"
          className="rounded-lg shadow-md mb-6 object-cover"
        />
        <h3 className="text-xl font-bold mb-4">Holistic Approach</h3>
        <p className="text-gray-700 mb-4">
          Staying true to our commitment, we provide personalised NDIS services
          with medical expertise.
        </p>
        <a
          href="/contact"
          className="text-green-700 font-semibold hover:underline inline-flex items-center"
        >
          Contact Us →
        </a>
      </div>

    </div>
  </div>
  </section>

 {/* Next Step */}
<section className="relative w-screen h-screen flex items-center justify-center sm:top-0 md:top-5 lg:top-10">
  {/* Background Image */}
  <img
    src="/images/AbhaGreyScale.jpg"
    alt="NextStepPicture"
    className="absolute inset-0 w-full h-full object-cover"
  />

  {/* Brown Overlay */}
  <div className="absolute inset-0 bg-[#8B5E3C] bg-opacity-50"></div>

  {/* Overlay Card */}
  <div className="relative z-10 bg-white text-gray-800 w-[90%] sm:w-[80%] md:w-[70%] lg:max-w-2xl px-6 sm:px-10 py-8 rounded-2xl shadow-lg text-center">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold font-inter mb-4">
      Ready to take the next step?
    </h2>
    <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 leading-relaxed font-inter">
      At ABHA CARE, our mission is to provide high-quality, person-centred NDIS care that 
      enhances your well-being and supports your independence. We're dedicated to empowering 
      you to engage with the community and achieve your personal goals. We’re here to help 
      you lead a fulfilling life!
    </p>
    <NavLink
      to="/contact"
      className="inline-block bg-[#8B5E3C] text-white font-semibold px-6 py-3 rounded-md shadow-md hover:bg-[#70492e] transition"
    >
      Get Started →
    </NavLink>
  </div>
</section>

{/*Info Section */}
<section className="bg-[#3f4f2b] text-white py-40">
  <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10 text-sm">
    {/* Logo + Location */}
    <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4">
      <img src="/images/Logo-inverted.svg" alt="ABHA CARE Logo" className="h-16 mx-auto md:mx-0" />
      <p className="font-semibold">New South Wales, Australia</p>
    </div>

    {/* Site Links */}
    <div>
      <h4 className="font-bold mb-4 text-lg">Site</h4>
      <ul className="space-y-2 text-lg">
        <li><NavLink to="/" className="hover:underline">Home</NavLink></li>
        <li><NavLink to="/about" className="hover:underline">About Us</NavLink></li>
        <li><NavLink to="/services" className="hover:underline">Services</NavLink></li>
        <li><NavLink to="/faq" className="hover:underline">FAQ</NavLink></li>
        <li><NavLink to="/contact" className="hover:underline">Contact Us</NavLink></li>
      </ul>
    </div>

    {/* Location + Hours */}
    <div>
      <h4 className="font-bold mb-4 text-lg">Location</h4>
      <p className="text-lg">Abha Care Pty Ltd<br />
        <br />
        </p>

      <h4 className="font-bold mt-6 mb-2 text-lg">Office Hours</h4>
      <p className="text-lg">
        Monday - Friday: 9:00AM - 5:00PM<br />
        Saturday & Sunday: Closed</p>
    </div>

    {/* Contact Info */}
    <div>
      <h4 className="font-bold mb-4 text-lg">Contact</h4>
      <p className="text-lg">Phone: 02 8395 2893<br /></p>
          <p className="text-lg  ml-14">1300 157 211<br /></p>
          <p className="mt-2 text-lg">
            <a href="mailto:info@abhacare.com.au" className="hover:underline text-lg">
              info@abhacare.com.au
            </a>
          </p>
    </div>
  </div>
  </section>
  </main>
  );
};

export default Home;
